module.exports = __webpack_public_path__ + "files/d0ca924fd70b0aac937ef92dbedc98ab.png";